import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import TypographyStyles from '../../styles/typography';

export class BOLInstructions extends Component {
  static propTypes = {
    shipment: PropTypes.shape({
      bolInstructions: PropTypes.string
    })
  };

  render() {
    const { classes, t, shipment } = this.props;

    return (
      <Fragment>
        <div className={classes.titleRootWrapper}>
          <h2 className={classes.headline7}>{t('BOL Instructions')}</h2>
        </div>
        <p className={classnames(classes.sectionContent, classes.body2Light)}>
          {shipment.bolInstructions}
        </p>
      </Fragment>
    );
  }
}

const BOLInstructionsWithTranslations = withNamespaces()(BOLInstructions);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles)
)(BOLInstructionsWithTranslations);
